// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isArrayGreaterThanOne = ( arr: any[]): boolean => {
  return arr.length > 1;
};
